import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router"
import ReportDailyPage from "@/app/report/daily/page"

function DailyReportLayout() {
  const location = useLocation()

  if (location.pathname === "/report/daily") {
    return <ReportDailyPage />
  }

  return <Outlet />
}

export const Route = createFileRoute("/report/daily")({
  component: DailyReportLayout,
})
